import {Component, Input, OnInit} from '@angular/core';
import {NxFooterModule} from '@aposin/ng-aquila/footer';
import {TranslateModule} from '@ngx-translate/core';
import {InformationFooterComponent} from '../information-footer/information-footer.component';
import {CapitalizePipe} from '../../../pipes/capitalize.pipe';
import {HeightStickyService} from '../../../services/height-sticky.service';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'fq-footer',
    imports: [CommonModule, NxFooterModule, TranslateModule, InformationFooterComponent, CapitalizePipe],
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss'
})
export class FooterComponent implements OnInit {
  readonly currentYear = new Date().getFullYear();
  content: Record<string, any> | null = null; // Inizializzato come null
  height!: number;

  @Input() isBigInformationFooter: boolean = false;
  @Input() showInformationFooter: boolean = true;

  constructor(private heightStickyService: HeightStickyService) {}

  ngOnInit() {
    this.heightStickyService.currentHeight.subscribe((height) => {
      this.height = height;
    });
  }
}
